import { render, staticRenderFns } from "./FilmDetail.vue?vue&type=template&id=2dd823bd&"
import script from "./FilmDetail.vue?vue&type=script&lang=js&"
export * from "./FilmDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FilmDetail.vue"
export default component.exports